import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal-900 pt-20 pb-10 border-t border-charcoal-700" data-id="element-144">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-145">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-146">
          <div className="lg:col-span-1" data-id="element-147">
            <a href="#" className="inline-block mb-6" aria-label="Nexora Resume home" data-id="element-148">
              <img src="https://cdn.magicpatterns.com/uploads/w9WU4iE2GPyhrtXEUgkLSw/ChatGPT_Image_Jun_25,_2026,_07_14_34_PM.png" alt="Nexora Resume" className="h-28 w-auto object-contain" data-id="element-149" />
            </a>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-150">
              Premium executive resume writing and branding services for leaders
              who shape the future of corporate governance.
            </p>
          </div>

          <div data-id="element-151">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-152">
              Services
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-153">
              <li data-id="element-154">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-155">
                  Board Resume Writing
                </a>
              </li>
              <li data-id="element-156">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-157">
                  Executive Resumes
                </a>
              </li>
              <li data-id="element-158">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-159">
                  LinkedIn Branding
                </a>
              </li>
              <li data-id="element-160">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-161">
                  Executive Biographies
                </a>
              </li>
              <li data-id="element-162">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-163">
                  Board Positioning
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-164">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-165">
              Company
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-166">
              <li data-id="element-167">
                <a href="#about" className="hover:text-gold transition-colors" data-id="element-168">
                  About Us
                </a>
              </li>
              <li data-id="element-169">
                <a href="#process" className="hover:text-gold transition-colors" data-id="element-170">
                  Our Process
                </a>
              </li>
              <li data-id="element-171">
                <a href="#testimonials" className="hover:text-gold transition-colors" data-id="element-172">
                  Success Stories
                </a>
              </li>
              <li data-id="element-173">
                <a href="#faq" className="hover:text-gold transition-colors" data-id="element-174">
                  FAQ
                </a>
              </li>
              <li data-id="element-175">
                <a href="#contact" className="hover:text-gold transition-colors" data-id="element-176">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-177">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-178">
              Contact
            </h4>
            <ul className="space-y-4 text-sm text-gray-400" data-id="element-179">
              <li className="flex items-start" data-id="element-180">
                <Mail className="w-5 h-5 text-gold mr-3 flex-shrink-0 mt-0.5" data-id="element-181" />
                <a href="mailto:executive@nexoraresume.com" className="hover:text-white transition-colors" data-id="element-182">
                  executive@nexoraresume.com
                </a>
              </li>
              <li className="flex items-start" data-id="element-183">
                <Phone className="w-5 h-5 text-gold mr-3 flex-shrink-0 mt-0.5" data-id="element-184" />
                <a href="tel:+18005550199" className="hover:text-white transition-colors" data-id="element-185">
                  +1 (800) 555-0199
                </a>
              </li>
              <li className="flex items-start" data-id="element-186">
                <MapPin className="w-5 h-5 text-gold mr-3 flex-shrink-0 mt-0.5" data-id="element-187" />
                <span data-id="element-188">
                  New York • London • Singapore
                  <br data-id="element-189" />
                  (Global Services)
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-navy-800 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-190">
          <p className="text-gray-500 text-sm mb-4 md:mb-0" data-id="element-191">
            &copy; {new Date().getFullYear()} Nexora Resume. All rights
            reserved.
          </p>
          <div className="flex space-x-6 text-sm text-gray-500" data-id="element-192">
            <a href="#" className="hover:text-white transition-colors" data-id="element-193">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-194">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}